import { ROOT_CONTEXT, context, propagation, type Context } from "@opentelemetry/api";
import { TRACE_PARENT_HEADER } from "@opentelemetry/core";
import { browser } from "$app/env";

export function activeContext(): Context {
	if (browser) {
		const metaElement = Array.from(document.getElementsByTagName("meta")).find(e => e.getAttribute("name") === TRACE_PARENT_HEADER);
		const traceparent = (metaElement && metaElement.content) || "";
		return propagation.extract(ROOT_CONTEXT, { traceparent });
	} else {
		return context.active();
	}
}
